module.exports = __webpack_public_path__ + "img/cultural-relic-desc.0c0a39b9.png";